import { render } from "./PaymentFormBillingAddress.vue?vue&type=template&id=52abbf22"
import script from "./PaymentFormBillingAddress.vue?vue&type=script&lang=js"
export * from "./PaymentFormBillingAddress.vue?vue&type=script&lang=js"

import "./PaymentFormBillingAddress.vue?vue&type=style&index=0&id=52abbf22&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__